export default "__VITE_ASSET__BalfmYu9__"